import { BaseMembersProps } from "@custom-types/member-types";
import { BulkButtonComponents } from "@components/common/faro-table/faro-table-types";
import { InviteMemberToTeam } from "@pages/members/teams/invite-member-to-team";
import { BaseTeamProps } from "@custom-types/teams-types";
import { useMembersMenuOptions } from "@pages/members/use-members-menu-options";
import { MemberMobileList } from "@components/common/mobile/member-mobile-list";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

interface Props extends BaseMembersProps, BaseTeamProps {
  /** List of all the bulk actions and callbacks */
  bulkActionButtons: BulkButtonComponents;

  /** Whether the data for showing a table is loading or not */
  isLoading: boolean;

  /** Current sort by value from the sort dropdown */
  sortBy: FaroCoreApiTypes.TeamMemberSortBy;
  
  /** Callback for loading more items (for pagination) */
  loadMoreItems: () => Promise<void>;
}

/**
 * Mobile-specific view for team members list.
 * Renders a virtualized list of team members with selection, menu options, and bulk actions.
 */
export function TeamMembersMobileView({
  members,
  bulkActionButtons,
  isLoading,
  sortBy,
  team,
  loadMoreItems,
}: Props): JSX.Element {
  const menuItems = useMembersMenuOptions({ subjectType: "team", team });

  const canInvite = !!team.memberCount && !team.category.isManaged;

  return (
    <MemberMobileList
      members={members}
      isLoading={isLoading}
      bulkActionButtons={bulkActionButtons}
      tableSubject="team"
      menuItems={menuItems}
      loadMoreItems={loadMoreItems}
      renderFooterExtra={() => (
        <InviteMemberToTeam team={team} buttonVariant="filled" />
      )}
      shouldShowFooterExtra={canInvite}
      sortBy={sortBy}
    />
  );
}
